import React, { Component } from 'react';
import MaskedInput from 'react-text-mask';
import { string, object } from 'yup';
import { FormGroup } from '../forms/FormBootstrap';
import { Formik } from 'formik';

class CadastroTelefones extends Component {
    constructor(props) {
        super(props);
        this.validationSchema = object().shape({
            telefone1: string()
                .required("Digite pelo menos um telefone válido"),
            telefone2: string()
        });

    }

    onSubmit(values, actions) {
        if (this.props.onSubmit) {
            this.props.onSubmit(values, actions);
        } else {
            console.log("No onSubmit prop");
        }
    }

    render() {
        const phoneMask = function (userInput) {
            let numbers = userInput.match(/\d/g);
            let numberLength = 0;
            if (numbers) {
                numberLength = numbers.join("").length;
            }

            if (numberLength > 10) {
                return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
            } else {
                return ['(', /[1-9]/, /[1-9]/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
            }
        }

        return <Formik
            onSubmit={(values, actions) => { this.onSubmit(values, actions) }}
            initialValues={{
                telefone1: '',
                telefone2: ''
            }}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={this.validationSchema}
            render={(props) => {
                const {
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                } = props;

                return (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <FormGroup errors={errors} touched={touched} campo="telefone1">
                                <label htmlFor="telefone1">Telefone 1 (fixo ou celular)</label>
                                <MaskedInput
                                    className="form-control"
                                    name="telefone1"
                                    placeholder="(00) 00000-0000"
                                    mask={phoneMask}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.telefone1}
                                />

                            </FormGroup>
                        </div>
                        <div className="row">

                            <FormGroup errors={errors} touched={touched} campo="telefone2">
                                <label htmlFor="telefone2">Telefone 2 (opcional)</label>
                                <MaskedInput
                                    className="form-control"
                                    name="telefone2"
                                    placeholder="(00) 00000-0000"
                                    mask={phoneMask}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.telefone2}
                                />
                            </FormGroup>
                        </div>
                        <div className="row">
                            <div className="form-group col-sm-6 col-sm-offset-3">
                                <button type="submit" className="btn btn-success pull-right">Avançar &gt;</button>
                            </div>
                        </div>
                    </form>
                );
            }
            } />
    }

}

export default CadastroTelefones;